import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { toast } from 'sonner';
import { initI18n } from '@/i18n/i18n';
import App from './App';

// i18n은 앱당 한 번만 초기화
initI18n({ debug: false });

// PWA Service Worker 등록/업데이트 처리
if ('serviceWorker' in navigator) {
  // VitePWA 플러그인이 생성한 virtual:pwa-register 모듈 사용
  import('virtual:pwa-register')
    .then(({ registerSW }) => {
      registerSW({
        immediate: true,
        onRegistered(_registration?: ServiceWorkerRegistration) {},
        onRegisterError(error: Error) {
          console.error('[Service Worker]Error:', error);
        },
        onNeedRefresh() {
          // 서비스워커 콜백은 React 트리 바깥이라 모달 훅을 못 쓰므로
          // 모듈 레벨 API인 sonner toast(액션 버튼)로 비차단 안내한다.
          toast('새 버전이 있습니다.', {
            description: '최신 버전으로 업데이트하려면 새로고침하세요.',
            duration: Infinity,
            action: {
              label: '새로고침',
              onClick: () => window.location.reload(),
            },
          });
        },
        onOfflineReady() {},
      });
    })
    .catch(error => {
      console.warn('[Service Worker] Error:', error);
      // 개발 모드에서는 virtual:pwa-register가 없을 수 있음
    });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
